import React, { useContext, useEffect, useState } from "react";
import * as Icons from "Components/Icons";
import { Button } from "Components/ReactstrapSlim";
import { Module } from "Components/Module";
import { IOnboardingContentViewModel, PortalClient } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import GetHelpModal from "../GetHelpModal";
import { HowItWorksModal } from "../HowItWorksModal";
import AccountContext from "../../AccountContext";

export const HelpModule: React.FC = () => {
   const account = useContext(AccountContext);
   const portalClient = useApiClient(PortalClient);

   const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);  
   const [showOnboardingModal, setShowOnboardingModal] = useState<boolean>(false);
   const [onboardingContent, setOnboardingContent] = useState<IOnboardingContentViewModel>();

   const toggleOnboardingModal = () => {
      setShowOnboardingModal(!showOnboardingModal);
   }

   useEffect(() => {
      portalClient.onboardingContent(account.id, undefined)
         .then(data => setOnboardingContent(data));
   }, []);

   const toggleSupportModal = () => {
      setIsSupportModalOpen(!isSupportModalOpen);
   }


  
   return (<Module size="lg" className="module-help">
      <div className="module-help-content">
         <div className="module-help-caption">Questions?</div>
         <div className="module-help-text">Check out the FAQ section to learn more about the program.</div>
         <div className="module-help-cta">
            <Button color="primary" size="lg" onClick={() => toggleSupportModal()}>Get help</Button>
         </div>
      </div>
      <div className="module-help-video" onClick={() => toggleOnboardingModal()}>
         <Button size="icon" color="white" className="btn-play-round">
            <Icons.Play />            
         </Button>
      </div>
      <GetHelpModal isOpen={isSupportModalOpen} toggle={toggleSupportModal} closeModal={toggleSupportModal} />      
      <HowItWorksModal isOpen={showOnboardingModal} toggle={toggleOnboardingModal} videoUrl={onboardingContent?.videoUrl} />
   </Module>);
}